module.exports = "<p>\n  credit-card-check works!\n</p>\n"